import { triggerDrawControl } from "../..";
import { sendTrackingEvent } from "../../utils/events";

let download_backButton = <HTMLButtonElement>document.querySelector('.download_backButton');
let download_shareButton = <HTMLButtonElement>document.querySelector('.download_shareButton');
let download_saveButton = <HTMLButtonElement>document.querySelector('.download_saveButton');
let download_saveShareButton = <HTMLButtonElement>document.querySelector('.download_saveShareButton');

export function initDownload() {

    download_backButton.addEventListener("touchend", () => {
        console.log('download back button pressed')
        triggerDrawControl('download_back');
    });

    download_saveButton.addEventListener("touchend", () => {
        sendTrackingEvent('User tapped Save (Android)')
        console.log('download share button pressed')
        triggerDrawControl('download_save');
    });

    download_shareButton.addEventListener("touchend", () => {
        sendTrackingEvent('User tapped Share (Android)')
        console.log('download share button pressed')
        triggerDrawControl('download_share');
    });


    download_saveShareButton.addEventListener("touchend", () => {
        sendTrackingEvent('User tapped Save or Share (iOS)')
        console.log('download save / share button pressed')
        triggerDrawControl('download_share');
    });
}